// ============================================================================
// This lib is for common hooks
// ============================================================================

import { useEffect, EffectCallback, useState } from "react";

export const useMountEffect = (effect: EffectCallback) => useEffect(effect, []);

// Live content width of the element the returned ref is attached to. Reports 0
// until the element is measured, and stays 0 where ResizeObserver is missing
// (jsdom), so callers must treat 0 as "unknown" and pick a sensible default.
export const useElementWidth = <T extends HTMLElement>(): [(element: T | null) => void, number] => {
    const [element, setElement] = useState<T | null>(null);
    const [width, setWidth] = useState(0);
    useEffect(() => {
        if (!element || typeof ResizeObserver === "undefined") return undefined;
        const observer = new ResizeObserver((entries) => {
            const entry = entries[0];
            if (entry) setWidth(entry.contentRect.width);
        });
        observer.observe(element);
        return () => observer.disconnect();
    }, [element]);
    return [setElement, width];
};
